import { useDateFormatSelect } from "store";
import { FormatDateUtil } from "store/types";
import { formatDate } from "utils";

export function useFormatDateHook(): FormatDateUtil {
  const formatFromConfig = useDateFormatSelect();

  return ({ format, ...rest }) => {
    return formatDate({ format: format || formatFromConfig, ...rest });
  };
}
